/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import LocalizedGender from '../../localization/LocalizedGender';

import { selectors as listSelectors } from '../../redux/ducks/lists/lists';

function mapStateToProps(state) {
  const genderCollection = listSelectors.getGenderCollection(state);
  const birthSexCollection = listSelectors.getBirthSexCollection(state);
  return {
    genderCollection,
    birthSexCollection,
    getInitialData: () => {},
  };
}

export default withRouter(connect(mapStateToProps)(LocalizedGender));
